
        var result = require("!!../../../../node_modules/css-loader/index.js!./loggers.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/loggers/loggers.component.css
// module id = 716
// module chunks = 0